<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col cols="12">
      <div
        style="
          font-size: 28px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          margin: 20px 0;
          color: #0581c6;
          font-weight: bold;
        "
      >
        {{ $t("components.PowerDataMainReport.title") }}
      </div>
      <div style="margin: 0 16px 20px 16px">
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.words.client") }}: </span
          ><span style="font-size: 16px">{{ tenant }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.labels.reportDate") }}: </span
          ><span style="font-size: 16px">{{ report_date }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.labels.reportTime") }}: </span
          ><span style="font-size: 16px">{{ report_time }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">{{ $t("common.words.recepients") }}: </span
          ><span style="font-size: 16px">{{ final_recepient }}</span>
          <span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
            ...+{{ recipients_number }} {{ $t("common.words.more") }}</span
          >
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        style="
          font-size: 24px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          color: #0581c6;
          font-weight: bold;
        "
      >
        {{ $t("common.labels.reportAtGlance") }}:
        <div class="primaryGrey--text text-caption">({{ $t("common.times.time.last24Hours") }})</div>
      </div>
    </v-col>
    <v-col cols="12">
      <v-row class="common-card-row">
        <v-col cols="12" md="6" class="pa-0 pr-md-3">
          <v-col class="common-card-col">
            <RadialChartVT
              v-if="this.devices_overview_data && faults_data"
              :title="page_content.faults_detected.title"
              :tooltip="page_content.faults_detected.tooltip"
              :chartData="faults_data"
            />
          </v-col>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 pr-md-3">
          <v-col class="common-card-col">
            <RadialChartVT
              v-if="this.devices_overview_data && quality_issues"
              :tooltip="page_content.power_quality_issues.tooltip"
              :title="page_content.power_quality_issues.title"
              :chartData="quality_issues"
            />
          </v-col>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-card flat>
        <v-card-title>
          {{ $t("common.labels.fleetOverview") }}
        </v-card-title>
        <v-card-subtitle>
          <b>{{ $t("common.labels.totalDevices") }}:</b>
          {{ devices && devices.length > 0 ? devices.length : "-" }}</v-card-subtitle
        >
        <v-card-text>
          <DataTableVT
            v-if="fleet_overview"
            :headers="config.issues_table"
            :items_list="fleet_overview"
            item_key="id"
            no_pagination="true"
            no_sort="true"
            print="true"
          />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card flat>
        <v-card-title>
          {{ $t("common.words.devices") }}
        </v-card-title>
        <v-card-subtitle>
          <b>Installed Devices:</b>
          {{
            installed_devices_data && installed_devices_data.length > 0 ? installed_devices_data.length : "-"
          }}</v-card-subtitle
        >
        <v-card-text>
          <DataTableVT
            v-if="computed_devices"
            sort_by="MaxUtilisation"
            :headers="config.devices_table"
            :items_list="computed_devices"
            item_key="id"
            no_sort="true"
            no_pagination="true"
            print="true"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DataTableVT from "../components/DataTableVT";
import RadialChartVT from "../components/RadialChartVT";
import { axios_get } from "../services/vt_service";
import { scv, trafo } from "../services/powerdata";
import { tracking } from "../services/tracking";
import { content } from "../../config/scavenger.js";
import { content as reports_config } from "../../config/powerdata_reports.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "ScavengerMainReport",
  components: {
    DataTableVT,
    RadialChartVT,
  },
  props: {},
  watch: {},
  data: function () {
    return {
      tenant: "",
      recepient: "",
      report_date: "",
      report_time: "",
      snackbar: false,
      network_error: false,
      devices: null,
      search_term: "",
      error_message: "",
      total_assets: 0,
      total_assets_known: 0,
      total_assets_unknown: 0,
      perc_assets_known: 0,
      perc_assets_unknown: 0,
      value_missing_assets: 0,
      deviceId: null,
      dialog: false,
      message: "",
      overview_data: null,
      current_list: "all",
      location_data: {},
      recipients_list: null,
      config: null,
      devices_overview_data: null,
      filtering_category: {},
      fleet_overview_data: null,
      installed_devices_data: null,
    };
  },
  created() {
    this.page_content = content;
    this.config = reports_config;
  },
  mounted() {
    if (this.$route.name == "Report_Snapshot") this.getRecipientsList();
    var d = new Date();
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0");
    var yyyy = d.getFullYear();
    var today = dd + "/" + mm + "/" + yyyy;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.report_date = today;
    this.report_time = d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + ":" + d.getSeconds();

    this.getDeviceList();
    this.getScvInstalledDevicesData();
    this.getScvDonutData(7);
    this.getFleetOverviewData();
  },
  filters: {},
  methods: {
    async getRecipientsList() {
      this.network_error = false;
      let response = await axios_get(tracking.get_report_recipients_list, { id: 1 });
      this.recipients_list = response[0];
    },
    async getScvInstalledDevicesData() {
      this.network_error = false;
      // let response = await axios_get(scv.get_installed_devices_report_data);
      let response = await scavenger_grpc_services.GetInstalledDevicesReportData();
      this.installed_devices_data = response;
    },
    async getScvDonutData(duration) {
      this.network_error = false;
      const response = await axios_get(scv.get_scv_donut_data, { duration });
      this.devices_overview_data = response;
    },
    async getFleetOverviewData() {
      this.network_error = false;
      // const response = await axios_get(scv.get_scv_report_data, { duration: 1 });
      const response = await scavenger_grpc_services.GetScvReportData(1);
      this.fleet_overview_data = response[0];
    },
    async getDeviceList() {
      this.network_error = false;
      let response = await axios_get(trafo.get_assets_data, { num_days: 1 });
      this.devices = response;
    },
    formatChartData(chart_data, config, type) {
      var data = [];
      this.filtering_category[type] = {};
      var others_total = 0;
      if (chart_data) {
        data = config.data.map((currentValue) => {
          others_total = 0;
          var total = 0;
          var result = chart_data.filter((data) => {
            total = total + data.Total;
            if (
              data.name &&
              !currentValue.values &&
              data.name.toLowerCase().trim() == currentValue.value.toLowerCase().trim()
            ) {
              this.filtering_category[type][currentValue.label] = currentValue.value.toUpperCase().trim();
              return true;
            } else if (data.name && !currentValue.value && currentValue.values) {
              others_total =
                others_total +
                (data.name && currentValue.values.indexOf(data.name.toLowerCase()) == -1 ? data.Total : 0);
              return true;
            } else {
              return false;
            }
          });
          var value = result[0] && result[0]["Total"];
          var final_val = currentValue.label == "Others" ? others_total : value;
          return [
            currentValue.label,
            final_val,
            {
              msg: currentValue.msg,
              title: currentValue.label,
              footer: `${this.$numberWithCommas(final_val)}(${this.$numberWithCommas(
                Math.round((final_val / total) * 10000) / 100
              )}%)`,
            },
          ];
        });
      } else {
        data = [config.header];
      }
      return data ? [config.header, ...data] : null;
    },
  },
  computed: {
    fleet_overview: function () {
      const data = [];
      if (this.fleet_overview_data && this.devices) {
        this.config.fleet_overview_items.map((elem) => {
          data.push({
            id: elem.id,
            issue: elem.label,
            totalDevices: this.fleet_overview_data[elem.id],
            percentageDevices: Math.round((this.fleet_overview_data[elem.id] / this.devices.length) * 10000) / 100,
          });
        });
      }
      return data;
    },
    final_recepient: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let recepients = "";
          let total = this.recipients_list.length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.recipients_list[i]["RecipientEmail"]
              : this.recipients_list[i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    recipients_number: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let total = this.recipients_list.length;
          return total > 7 ? total - 7 : null;
        }
        return null;
      }
      return null;
    },
    computed_devices: function () {
      let installed_devices = [];
      this.devices && this.installed_devices_data
        ? this.installed_devices_data.forEach((device) => {
            // merge installed device data and device data to get the final data and push it to installed_devices
            let installed_device = this.devices.find((d) => d.DeviceID == device.DeviceID);
            if (installed_device) {
              installed_devices.push({ ...installed_device, ...device });
            }
          })
        : null;
      return installed_devices;
    },
    faults_data: function () {
      let faults = [];
      this.devices_overview_data &&
        this.devices_overview_data["faultsData"].map((e) => {
          faults.push({ name: e.name, Total: e.total });
        });
      return faults ? this.formatChartData(faults, this.page_content.faults_detected, "faults_data") : [];
    },
    quality_issues: function () {
      let quality_issues = [];
      this.devices_overview_data &&
        this.devices_overview_data["qualityIssues"].map((e) => {
          quality_issues.push({ name: e.name, Total: e.total });
        });
      return quality_issues
        ? this.formatChartData(quality_issues, this.page_content.power_quality_issues, "quality_issues")
        : [];
    },
  },
};
</script>
